import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Spin } from 'antd';
import QR from 'qrcode';
import moment from 'moment';

const QrCode = ({ id }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const canvasRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const renderQr = async () => {
      if (!show) return;
      if (!canvasRef.current) return;
      if (!id) return;

      try {
        setLoading(true);

        await QR.toCanvas(canvasRef.current, String(id), {
          width: 250,
          height: 250,
          margin: 1,
        });

        if (!cancelled) {
          setLoading(false);
        }
      } catch (err) {
        console.error('Failed to render QR code:', err);
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    renderQr();

    return () => {
      cancelled = true;
    };
  }, [show, id]);

  const download = () => {
    const thisCanvas = canvasRef.current;
    if (!thisCanvas) return;

    const link = document.createElement('a');
    link.download = `qr-code-${moment().format('YYYY-MM-DD-HH-mm-ss')}.jpeg`;
    link.href = thisCanvas.toDataURL('image/jpeg');
    link.click();
  };

  return (
    <>
      <Modal
        visible={show}
        title="QR Code"
        cancelButtonProps={{ style: { display: 'none' } }}
        okText="Download"
        onOk={download}
        onCancel={() => setShow(false)}
        destroyOnClose
      >
        <Spin spinning={loading}>
          <div className="d-flex jc-center" style={{ minHeight: 260, alignItems: 'center' }}>
            {id ? <canvas ref={canvasRef} /> : <div>No QR code available</div>}
          </div>
        </Spin>
      </Modal>

      <Button onClick={() => setShow(true)} disabled={!id}>
        QR Code
      </Button>
    </>
  );
};

export default QrCode;